export const environment = {
  production: false,
  authUrl: 'https://api-access-gateway.techlabz.in/etp-be-dev',
  url: {
    defaultUrl: 'https://api-access-gateway.techlabz.in/munawel-be-staging/graphql',
    hrmsModuleUrl: 'https://api-access-gateway.techlabz.in/etp-hrms-dev/graphql',
    accountsUrl: 'https://api-access-gateway.techlabz.in/etp-accounts-dev/graphql',
    // projectModuleUrl: 'https://shyam-82.twl-workspace.techwarelab.com/graphql',
    projectModuleUrl: 'https://api-access-gateway.techlabz.in/etp-projects-dev/graphql',
    // accountsUrl: 'https://sharon-4200.twl-workspace.techwarelab.com/graphql',
    // accountsUrl: 'https://godwin-4200.tl-workspace.techwarelab.com/graphql',
    communicationModuleUrl:
    // 'https://api-access-gateway.techlabz.in/etp-communication-staging/graphql',
    'https://shyam-4200.twl-workspace.techwarelab.com/graphql',
    websocketUrl:
        'wss://shyam-4200.twl-workspace.techwarelab.com/graphql'
    //     // 'wss://sharon-82.twl-workspace.techwarelab.com/graphql'
    //     'wss://api-access-gateway.techlabz.in/munawel-communication-staging/graphql'
  },
};